import { z } from 'zod';
import {
  FindingSeveritySchema,
  FindingStatusSchema,
  JsonValueSchema,
  SignalCategorySchema,
  TargetTypeSchema,
  InfraImpactSchema,
  BusinessRiskSchema,
} from '@terra/shared-schemas-orchestrator';
import { AssetLifecycleDtoSchema } from '@terra/shared-dto-types';
import { FindingTypeFieldsSchema } from './finding-type.schema';
import { FindingCvssVersionFieldsSchema } from './finding-cvss-versions.schema';

export const BaseFindingDtoSchema = z.object({
  id: z.string(),
  tenantId: z.string().nullable(),
  targetId: z.string(),
  targetType: TargetTypeSchema,
  executionStateId: z.string().nullable(),
  traceThreadId: z.string().nullable(),
  signalId: z.string().nullable(),
  status: FindingStatusSchema,
  severity: FindingSeveritySchema,
  category: SignalCategorySchema.nullable(),
  cweIds: z.array(z.string()).default([]),
  owaspCategory: z.string().nullable(),
  title: z.string(),
  shortDescription: z.string().nullable(),
  assignedTo: z.string(),
  discoveryDate: z.coerce.date(),
  publishedAt: z.coerce.date().nullable(),
  resolvedAt: z.coerce.date().nullable(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  filePath: z.string().nullable(),
  metadata: JsonValueSchema.nullable(),
  findingUpdateComment: z.string().nullable(),
  hasRetests: z.boolean(),
  retestThreadIds: z.array(z.string()),
  constituentFindingIds: z.array(z.string()).default([]),
  infraImpact: InfraImpactSchema.nullable().optional(),
  businessRisk: BusinessRiskSchema.nullable().optional(),
  ...FindingTypeFieldsSchema.shape,
  ...FindingCvssVersionFieldsSchema.shape,
  pendingProposedSeverity: FindingSeveritySchema.nullable().optional(),
  lifecycle: AssetLifecycleDtoSchema.optional(),
});

export type BaseFindingDto = z.infer<typeof BaseFindingDtoSchema>;

export const BaseAppFindingDtoSchema = BaseFindingDtoSchema.extend({
  applicationId: z.string(),
});

export type BaseAppFindingDto = z.infer<typeof BaseAppFindingDtoSchema>;
